/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Portfolio.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddTransactionsRequest
 */
export interface AddTransactionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AddTransactionsRequest
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {Array<TransactionData>}
     * @memberof AddTransactionsRequest
     */
    'transactions'?: Array<TransactionData>;
}
/**
 * 
 * @export
 * @interface AddTransactionsResponse
 */
export interface AddTransactionsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddTransactionsResponse
     */
    'transactionIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface CreatePortfolioRequest
 */
export interface CreatePortfolioRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePortfolioRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DailyValuation
 */
export interface DailyValuation {
    /**
     * 
     * @type {number}
     * @memberof DailyValuation
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyValuation
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyValuation
     */
    'index'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyValuation
     */
    'pnl'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyValuation
     */
    'pnlRate'?: number;
}
/**
 * 
 * @export
 * @interface DailyValue
 */
export interface DailyValue {
    /**
     * 
     * @type {number}
     * @memberof DailyValue
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyValue
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface DeletePortfolioRequest
 */
export interface DeletePortfolioRequest {
    /**
     * 
     * @type {string}
     * @memberof DeletePortfolioRequest
     */
    'portfolioId'?: string;
}
/**
 * 
 * @export
 * @interface DeleteTransactionRequest
 */
export interface DeleteTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteTransactionRequest
     */
    'transactionId'?: string;
}
/**
 * 
 * @export
 * @interface EntityDailyValue
 */
export interface EntityDailyValue {
    /**
     * 
     * @type {string}
     * @memberof EntityDailyValue
     */
    'entityId'?: string;
    /**
     * 
     * @type {Array<DailyValue>}
     * @memberof EntityDailyValue
     */
    'values'?: Array<DailyValue>;
}
/**
 * 
 * @export
 * @interface GetCloseValuesResponse
 */
export interface GetCloseValuesResponse {
    /**
     * 
     * @type {Array<EntityDailyValue>}
     * @memberof GetCloseValuesResponse
     */
    'entityCloseValues'?: Array<EntityDailyValue>;
}
/**
 * 
 * @export
 * @interface GetPortfoliosResponse
 */
export interface GetPortfoliosResponse {
    /**
     * 
     * @type {Array<Portfolio>}
     * @memberof GetPortfoliosResponse
     */
    'portfolios'?: Array<Portfolio>;
}
/**
 * 
 * @export
 * @interface GetTransactionsResponse
 */
export interface GetTransactionsResponse {
    /**
     * 
     * @type {Array<Transaction>}
     * @memberof GetTransactionsResponse
     */
    'transactions'?: Array<Transaction>;
}
/**
 * 
 * @export
 * @interface Portfolio
 */
export interface Portfolio {
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof Portfolio
     */
    'transactionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Portfolio
     */
    'firstTransactionDate'?: number;
    /**
     * 
     * @type {number}
     * @memberof Portfolio
     */
    'lastTransactionDate'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Portfolio
     */
    'entities'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Portfolio
     */
    'readOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Portfolio
     */
    'netTransactionValue'?: number;
    /**
     * 
     * @type {SimulatePortfolioResponse}
     * @memberof Portfolio
     */
    'simulation'?: SimulatePortfolioResponse;
}
/**
 * 
 * @export
 * @interface RenamePortfolioRequest
 */
export interface RenamePortfolioRequest {
    /**
     * 
     * @type {string}
     * @memberof RenamePortfolioRequest
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RenamePortfolioRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SimulatePortfolioResponse
 */
export interface SimulatePortfolioResponse {
    /**
     * 
     * @type {Array<DailyValuation>}
     * @memberof SimulatePortfolioResponse
     */
    'dailyValuations'?: Array<DailyValuation>;
    /**
     * 
     * @type {DailyValuation}
     * @memberof SimulatePortfolioResponse
     */
    'initialDayValuation'?: DailyValuation;
    /**
     * 
     * @type {number}
     * @memberof SimulatePortfolioResponse
     */
    'pnl'?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulatePortfolioResponse
     */
    'pnlRate'?: number;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'nominal'?: number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'commissionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'entityCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'entityUniqueCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'close'?: number;
}
/**
 * 
 * @export
 * @interface TransactionData
 */
export interface TransactionData {
    /**
     * 
     * @type {string}
     * @memberof TransactionData
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionData
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionData
     */
    'nominal'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionData
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionData
     */
    'commissionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionData
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UpdateTransactionRequest
 */
export interface UpdateTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    'portfolioId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    'date'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    'nominal'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    'commissionRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    'description'?: string;
}

/**
 * PortfolioServiceApi - axios parameter creator
 * @export
 */
export const PortfolioServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {Array<string>} [entityIds] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CloseValuesGet: async (identityToken: string, entityIds?: Array<string>, startDate?: number, endDate?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1CloseValuesGet', 'identityToken', identityToken)
            const localVarPath = `/v1/close-values`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityIds) {
                localVarQueryParameter['entityIds'] = entityIds;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CreatePortfolioRequest} [createPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioCreatePost: async (identityToken: string, createPortfolioRequest?: CreatePortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1PortfolioCreatePost', 'identityToken', identityToken)
            const localVarPath = `/v1/portfolio/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeletePortfolioRequest} [deletePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioDeletePost: async (identityToken: string, deletePortfolioRequest?: DeletePortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1PortfolioDeletePost', 'identityToken', identityToken)
            const localVarPath = `/v1/portfolio/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {RenamePortfolioRequest} [renamePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioRenamePost: async (identityToken: string, renamePortfolioRequest?: RenamePortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1PortfolioRenamePost', 'identityToken', identityToken)
            const localVarPath = `/v1/portfolio/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(renamePortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [date] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioSimulateGet: async (identityToken: string, portfolioId?: string, date?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1PortfolioSimulateGet', 'identityToken', identityToken)
            const localVarPath = `/v1/portfolio/simulate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (portfolioId !== undefined) {
                localVarQueryParameter['portfolioId'] = portfolioId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {number} [simulationDate] 
         * @param {number} [simulationLimit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfoliosGet: async (identityToken: string, simulationDate?: number, simulationLimit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1PortfoliosGet', 'identityToken', identityToken)
            const localVarPath = `/v1/portfolios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (simulationDate !== undefined) {
                localVarQueryParameter['simulation.date'] = simulationDate;
            }

            if (simulationLimit !== undefined) {
                localVarQueryParameter['simulation.limit'] = simulationLimit;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {AddTransactionsRequest} [addTransactionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionAddPost: async (identityToken: string, addTransactionsRequest?: AddTransactionsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1TransactionAddPost', 'identityToken', identityToken)
            const localVarPath = `/v1/transaction/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTransactionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeleteTransactionRequest} [deleteTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionDeletePost: async (identityToken: string, deleteTransactionRequest?: DeleteTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1TransactionDeletePost', 'identityToken', identityToken)
            const localVarPath = `/v1/transaction/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateTransactionRequest} [updateTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionUpdatePost: async (identityToken: string, updateTransactionRequest?: UpdateTransactionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1TransactionUpdatePost', 'identityToken', identityToken)
            const localVarPath = `/v1/transaction/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [paginationPageSize] 
         * @param {number} [paginationPageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionsGet: async (identityToken: string, portfolioId?: string, paginationPageSize?: number, paginationPageNumber?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('v1TransactionsGet', 'identityToken', identityToken)
            const localVarPath = `/v1/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (portfolioId !== undefined) {
                localVarQueryParameter['portfolioId'] = portfolioId;
            }

            if (paginationPageSize !== undefined) {
                localVarQueryParameter['pagination.pageSize'] = paginationPageSize;
            }

            if (paginationPageNumber !== undefined) {
                localVarQueryParameter['pagination.pageNumber'] = paginationPageNumber;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioServiceApi - functional programming interface
 * @export
 */
export const PortfolioServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {Array<string>} [entityIds] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1CloseValuesGet(identityToken: string, entityIds?: Array<string>, startDate?: number, endDate?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCloseValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1CloseValuesGet(identityToken, entityIds, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CreatePortfolioRequest} [createPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PortfolioCreatePost(identityToken: string, createPortfolioRequest?: CreatePortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PortfolioCreatePost(identityToken, createPortfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeletePortfolioRequest} [deletePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PortfolioDeletePost(identityToken: string, deletePortfolioRequest?: DeletePortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PortfolioDeletePost(identityToken, deletePortfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {RenamePortfolioRequest} [renamePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PortfolioRenamePost(identityToken: string, renamePortfolioRequest?: RenamePortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PortfolioRenamePost(identityToken, renamePortfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [date] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PortfolioSimulateGet(identityToken: string, portfolioId?: string, date?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulatePortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PortfolioSimulateGet(identityToken, portfolioId, date, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {number} [simulationDate] 
         * @param {number} [simulationLimit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PortfoliosGet(identityToken: string, simulationDate?: number, simulationLimit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPortfoliosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1PortfoliosGet(identityToken, simulationDate, simulationLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {AddTransactionsRequest} [addTransactionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1TransactionAddPost(identityToken: string, addTransactionsRequest?: AddTransactionsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1TransactionAddPost(identityToken, addTransactionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeleteTransactionRequest} [deleteTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1TransactionDeletePost(identityToken: string, deleteTransactionRequest?: DeleteTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1TransactionDeletePost(identityToken, deleteTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateTransactionRequest} [updateTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1TransactionUpdatePost(identityToken: string, updateTransactionRequest?: UpdateTransactionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1TransactionUpdatePost(identityToken, updateTransactionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [paginationPageSize] 
         * @param {number} [paginationPageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1TransactionsGet(identityToken: string, portfolioId?: string, paginationPageSize?: number, paginationPageNumber?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.v1TransactionsGet(identityToken, portfolioId, paginationPageSize, paginationPageNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioServiceApi - factory interface
 * @export
 */
export const PortfolioServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {Array<string>} [entityIds] 
         * @param {number} [startDate] 
         * @param {number} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CloseValuesGet(identityToken: string, entityIds?: Array<string>, startDate?: number, endDate?: number, options?: any): AxiosPromise<GetCloseValuesResponse> {
            return localVarFp.v1CloseValuesGet(identityToken, entityIds, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {CreatePortfolioRequest} [createPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioCreatePost(identityToken: string, createPortfolioRequest?: CreatePortfolioRequest, options?: any): AxiosPromise<Portfolio> {
            return localVarFp.v1PortfolioCreatePost(identityToken, createPortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeletePortfolioRequest} [deletePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioDeletePost(identityToken: string, deletePortfolioRequest?: DeletePortfolioRequest, options?: any): AxiosPromise<object> {
            return localVarFp.v1PortfolioDeletePost(identityToken, deletePortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {RenamePortfolioRequest} [renamePortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioRenamePost(identityToken: string, renamePortfolioRequest?: RenamePortfolioRequest, options?: any): AxiosPromise<object> {
            return localVarFp.v1PortfolioRenamePost(identityToken, renamePortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [date] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfolioSimulateGet(identityToken: string, portfolioId?: string, date?: number, limit?: number, options?: any): AxiosPromise<SimulatePortfolioResponse> {
            return localVarFp.v1PortfolioSimulateGet(identityToken, portfolioId, date, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {number} [simulationDate] 
         * @param {number} [simulationLimit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PortfoliosGet(identityToken: string, simulationDate?: number, simulationLimit?: number, options?: any): AxiosPromise<GetPortfoliosResponse> {
            return localVarFp.v1PortfoliosGet(identityToken, simulationDate, simulationLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {AddTransactionsRequest} [addTransactionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionAddPost(identityToken: string, addTransactionsRequest?: AddTransactionsRequest, options?: any): AxiosPromise<AddTransactionsResponse> {
            return localVarFp.v1TransactionAddPost(identityToken, addTransactionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {DeleteTransactionRequest} [deleteTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionDeletePost(identityToken: string, deleteTransactionRequest?: DeleteTransactionRequest, options?: any): AxiosPromise<object> {
            return localVarFp.v1TransactionDeletePost(identityToken, deleteTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateTransactionRequest} [updateTransactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionUpdatePost(identityToken: string, updateTransactionRequest?: UpdateTransactionRequest, options?: any): AxiosPromise<object> {
            return localVarFp.v1TransactionUpdatePost(identityToken, updateTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [portfolioId] 
         * @param {number} [paginationPageSize] 
         * @param {number} [paginationPageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1TransactionsGet(identityToken: string, portfolioId?: string, paginationPageSize?: number, paginationPageNumber?: number, options?: any): AxiosPromise<GetTransactionsResponse> {
            return localVarFp.v1TransactionsGet(identityToken, portfolioId, paginationPageSize, paginationPageNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioServiceApi - object-oriented interface
 * @export
 * @class PortfolioServiceApi
 * @extends {BaseAPI}
 */
export class PortfolioServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {Array<string>} [entityIds] 
     * @param {number} [startDate] 
     * @param {number} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1CloseValuesGet(identityToken: string, entityIds?: Array<string>, startDate?: number, endDate?: number, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1CloseValuesGet(identityToken, entityIds, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {CreatePortfolioRequest} [createPortfolioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1PortfolioCreatePost(identityToken: string, createPortfolioRequest?: CreatePortfolioRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1PortfolioCreatePost(identityToken, createPortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {DeletePortfolioRequest} [deletePortfolioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1PortfolioDeletePost(identityToken: string, deletePortfolioRequest?: DeletePortfolioRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1PortfolioDeletePost(identityToken, deletePortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {RenamePortfolioRequest} [renamePortfolioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1PortfolioRenamePost(identityToken: string, renamePortfolioRequest?: RenamePortfolioRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1PortfolioRenamePost(identityToken, renamePortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [portfolioId] 
     * @param {number} [date] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1PortfolioSimulateGet(identityToken: string, portfolioId?: string, date?: number, limit?: number, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1PortfolioSimulateGet(identityToken, portfolioId, date, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {number} [simulationDate] 
     * @param {number} [simulationLimit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1PortfoliosGet(identityToken: string, simulationDate?: number, simulationLimit?: number, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1PortfoliosGet(identityToken, simulationDate, simulationLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {AddTransactionsRequest} [addTransactionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1TransactionAddPost(identityToken: string, addTransactionsRequest?: AddTransactionsRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1TransactionAddPost(identityToken, addTransactionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {DeleteTransactionRequest} [deleteTransactionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1TransactionDeletePost(identityToken: string, deleteTransactionRequest?: DeleteTransactionRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1TransactionDeletePost(identityToken, deleteTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {UpdateTransactionRequest} [updateTransactionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1TransactionUpdatePost(identityToken: string, updateTransactionRequest?: UpdateTransactionRequest, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1TransactionUpdatePost(identityToken, updateTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [portfolioId] 
     * @param {number} [paginationPageSize] 
     * @param {number} [paginationPageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioServiceApi
     */
    public v1TransactionsGet(identityToken: string, portfolioId?: string, paginationPageSize?: number, paginationPageNumber?: number, options?: AxiosRequestConfig) {
        return PortfolioServiceApiFp(this.configuration).v1TransactionsGet(identityToken, portfolioId, paginationPageSize, paginationPageNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



